import { authenticationService } from './authenticationService';

export const xencallService = {
	getClients,
	getStripeCustomers,
	getCustomerPortalUrl,
	migrateClient,
	getClientSubscriptions,
	updateClientSubscriptions,
	cancelScheduledUpdate,
	getSubscriptions,
	createSubscription,
};

const axios = require('axios');

function getClients(self, type) {
	axios
		.get(authenticationService.getBaseUrl() + '/api/v1/clients?migrated=' + type, {
			headers: {
				Authorization: 'Bearer ' + authenticationService.getAccessToken(),
			},
		})
		.then(function(response) {
			console.log(response.data);
			self.setState({
				clients: response.data,
			});
		})
		.catch((error) => {
			authenticationService.handleHttpError(error);
		});
}

function getStripeCustomers(self) {
	axios
		.get(authenticationService.getBaseUrl() + '/api/v1/customers', {
			headers: {
				Authorization: 'Bearer ' + authenticationService.getAccessToken(),
			},
		})
		.then(function(response) {
			console.log(response.data);
			if (response.data && response.data.length === 0) {
				getCustomerPortalUrl(self, 0);
			} else {
				self.setState({
					admin: true,
					clients: response.data,
				});
			}
		})
		.catch((error) => {
			authenticationService.handleHttpError(error);
		});
}

function getCustomerPortalUrl(self, clientId) {
	axios
		.get(authenticationService.getBaseUrl() + '/api/v1/customer-portal-url?clientId=' + clientId, {
			headers: {
				Authorization: 'Bearer ' + authenticationService.getAccessToken(),
			},
		})
		.then(function(response) {
			console.log(response.data);
			self.setState({
				customerPortalUrl: response.data,
			});
		})
		.catch((error) => {
			authenticationService.handleHttpError(error);
		});
}

function migrateClient(self, id) {
	axios
		.post(
			authenticationService.getBaseUrl() + '/api/v1/migrate?id=' + id,
			{},
			{
				headers: {
					Authorization: 'Bearer ' + authenticationService.getAccessToken(),
				},
			}
		)
		.then(function(response) {
			console.log(response.data);
			self.setState({
				stage: response.data === 'OK' ? 2 : 0,
			});
		})
		.catch((error) => {
			//authenticationService.handleHttpError(error);
		});
}

function getClientSubscriptions() {
	return axios
		.get(
			authenticationService.getBaseUrl() +
				'/api/v1/customer-subscriptions/' +
				authenticationService.getClientId(),
			{
				headers: {
					Authorization: 'Bearer ' + authenticationService.getAccessToken(),
				},
			}
		)
		.then(function(response) {
			console.log(response.data);
			return response.data;
		})
		.catch((error) => {
			authenticationService.handleHttpError(error);
		});
}

function cancelScheduledUpdate() {
	return axios
		.post(
			authenticationService.getBaseUrl() +
				'/api/v1/customer-subscription_schedule/' +
				authenticationService.getClientId() + '/cancel', null,
			{
				headers: {
					Authorization: 'Bearer ' + authenticationService.getAccessToken(),
				},
			}
		)
		.then(function(response) {
			console.log(response.data);
			return response.data;
		})
		.catch((error) => {
			authenticationService.handleHttpError(error);
		});
}

function updateClientSubscriptions(parms) {
	return axios
		.post(
			authenticationService.getBaseUrl() +
				'/api/v1/customer-subscriptions/' +
				authenticationService.getClientId(),
			JSON.stringify(parms),
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: 'Bearer ' + authenticationService.getAccessToken(),
				},
			}
		)
		.then(function(response) {
			console.log(response);
			return response;
		})
		.catch((error) => {
			authenticationService.handleHttpError(error);
		});
}

function getSubscriptions(self, stripeid) {
	axios
		.get(authenticationService.getBaseUrl() + '/api/v1/subscriptions?customerId=' + stripeid, {
			headers: {
				Authorization: 'Bearer ' + authenticationService.getAccessToken(),
			},
		})
		.then(function(response) {
			console.log(response.data);
			self.setState({
				subscriptions: response.data ? response.data.data : [],
			});
		})
		.catch((error) => {
			authenticationService.handleHttpError(error);
		});
}

function createSubscription(self, customerId, backdate_start_date, billing_cycle_anchor, planId) {
	axios
		.post(
			authenticationService.getBaseUrl() +
				'/api/v1/subscriptions?customerId=' +
				customerId +
				'&backdate_start_date=' +
				backdate_start_date +
				'&billing_cycle_anchor=' +
				billing_cycle_anchor +
				'&planId=' +
				planId,
			{},
			{
				headers: {
					Authorization: 'Bearer ' + authenticationService.getAccessToken(),
				},
			}
		)
		.then(function(response) {
			console.log(response.data);
			self.setState({
				stage: response.data === 'OK' ? 2 : 0,
			});
		})
		.catch((error) => {
			authenticationService.handleHttpError(error);
		});
}
